// @ts-nocheck
 import colleagueAssist  from '/tmp/build/src/packages/onejsProject/src/pages/colleagueAssist/store/colleagueAssist.ts'
import colleagueAssistPass  from '/tmp/build/src/packages/onejsProject/src/pages/colleagueAssistPass/store/colleagueAssistPass.ts'
import todo  from '/tmp/build/src/packages/onejsProject/src/pages/todo/store/todo.ts'
import forgetPwdStore  from '/tmp/build/src/packages/onejsProject/src/pages/forgetPassword/store/forgetPwdStore.ts'

class RootStore {
 colleagueAssist = new colleagueAssist(this)
colleagueAssistPass = new colleagueAssistPass(this)
todo = new todo(this)
forgetPwdStore = new forgetPwdStore(this)
}

const mobx_stores = new RootStore();
window.mobx_app = {
  mobx_stores,
}
